type AttachmentsAttribute = Record<string, any>

export interface IAnswerTaskModel {
  id?: number
  blockInstanceId: number
  attachmentsAttributes: AttachmentsAttribute
  token?: string
}

export const answerLikerInitialState: IAnswerTaskModel = {
  blockInstanceId: 0,
  attachmentsAttributes: {},
}

export const answerTask = (
  blockInstanceId: number,
  attachmentsAttributes: AttachmentsAttribute
): IAnswerTaskModel => {
  const task = answerLikerInitialState
  task.blockInstanceId = blockInstanceId
  task.attachmentsAttributes = attachmentsAttributes
  return task
}
